import type { PrintElement } from "../core/types";

export interface PageSegment {
  elements: PrintElement[];
  manualBreakAfter: boolean;
}

// Split the flat print element stream into logical preview pages. This module
// intentionally stays pure and only understands explicit break markers; it does
// not perform DOM measurement or estimated automatic pagination.
export function paginateElements(
  elements: PrintElement[],
  options: {
    respectPageBreaks?: boolean;
  } = {}
): PageSegment[] {
  const segments: PageSegment[] = [];
  let current: PrintElement[] = [];

  const pushSegment = (manualBreakAfter = false) => {
    if (!current.length) {
      return;
    }

    segments.push({
      elements: current,
      manualBreakAfter
    });
    current = [];
  };

  for (const element of elements) {
    if (element.kind === "pageBreak") {
      if (options.respectPageBreaks !== false) {
        pushSegment(true);
      }
      continue;
    }

    if (element.pageBreakBefore) {
      pushSegment(true);
    }

    current.push(element);

    if (element.pageBreakAfter) {
      pushSegment(true);
    }
  }

  pushSegment(false);

  return segments.length ? segments : [{ elements: [], manualBreakAfter: false }];
}
